import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import "./Styles/phoneFooter.css";
import { getWebPhoneDomain, getIsDebug, logData } from "../utils/utils";
import { Tooltip } from "react-bootstrap";
import { EXPIRE, ID_TOKEN, REFRESH_TOKEN } from "../utils/authutils";
import {showWebphone} from '../actions/call';
import {
    set_showInvalidAudioSettingsMessage
} from "../actions/common";


class PhoneFooter extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showPhone: false,
    };
    this.isWebAgentActive = true;
    this.srcUrl = "";
  }

  componentDidMount = () => {
    window.addEventListener("message", this.handleMessage, false);

    if (document.getElementById("phone-iframe") && this.srcUrl) {
      document.getElementById("phone-iframe").allow = "microphone";
      document.getElementById("phone-iframe").src = this.srcUrl;
    }

    //---------------------------------------------
    // Determinar si se debe abrir el webphone si tiene error de devices.
    const { set_showInvalidAudioSettingsMessage } = this.props;
    let { showInvalidAudioSettingsMessage } = this.props;

    // console.log('showInvalidAudioSettingsMessage: ', showInvalidAudioSettingsMessage);
    if (showInvalidAudioSettingsMessage === true)
    {
        // console.log('SHOW!!!!');
        this.props.showWebphone(true);

        set_showInvalidAudioSettingsMessage(false);
    }
    //---------------------------------------------

  };

  componentWillReceiveProps(nextProps) {
	if (nextProps.openPhone === true && this.props.openPhone === false) {
	  this.showPhonePopup(true);
    }
  }

  handleMessage = (e) => {
    const webphoneDomain = getWebPhoneDomain();
   // console.log('webphone domain: ' + webphoneDomain);

    if (e.data.domain === webphoneDomain) {
     // console.log("componentDidMount");

      if (e.data.message === "LOGIN_SUCCEEDED") {
        logData("login succeeded");
        //console.log("login succeeded");
        let data = {
          RefreshToken: localStorage.getItem(REFRESH_TOKEN),
          TokenType: "Bearer",
        };
        setTimeout(function () {
          var webphoneElement = document.getElementById("phone-iframe")
            ? document.getElementById("phone-iframe").contentWindow
            : null;
          if (webphoneElement) {
            webphoneElement.postMessage(data, webphoneDomain);
           // console.log(webphoneElement.postMessage(data, webphoneDomain));
          }
        }, 1000);
      } else if (e.data.message === "INCOMING_CALL") {
        this.setState({
          showPhone: true,
        });
      }
    }
  };

  togglePhonePopup = () => {
    if (this.state.showPhone === true) {
      this.showPhonePopup(false);
    } else if (this.state.showPhone === false) {
      this.showPhonePopup(true);
    }
  };

  showPhonePopup = (show) => {
    this.setState({ showPhone: show });
    if(!show) this.props.showWebphone(false);
  };

  render() {
    let idToken = localStorage.getItem(ID_TOKEN);
    let refreshToken = localStorage.getItem(REFRESH_TOKEN);
    let expire = localStorage.getItem(EXPIRE);
    let location = window.location.href;
    let env = "";
    let webphoneDomain = "";

    //NOTE    - Two environments:
    //        - domain + webphone: old webagent version + latest webphone (agentgo.invoxcontact.com/webphone)
    //        - domain + webphonego: new webagent version + latest webphone (go.invoxcontact.io/webphonego)

    //check JIRA issue: https://numintec.atlassian.net/jira/software/projects/FE/boards/51?selectedIssue=FE-57

    if (location.includes("test.invoxcontact.io")) {
      env = "dev";
       webphoneDomain = "https://test.invoxcontact.io/22/webphonego/";
      // webphoneDomain = "https://test.invoxcontact.io/webphone/";
    } else if (location.includes("staging.invoxcontact.io")) {
      env = "stage";
      webphoneDomain = "https://staging.invoxcontact.io/22/webphonego/";
    } else if (location.includes("go.invoxcontact.io")) {
      env = "prod";
      webphoneDomain = "https://go.invoxcontact.io/22/webphonego/";    
    } else {
      env = "local";
      webphoneDomain = "http://localhost:3001";
    }

    if (
      !this.props.agentInfo.extension ||
      !idToken ||
      !refreshToken ||
      !expire
    ) {
      return null;
    }

    this.srcUrl =
      webphoneDomain +
      "?token=" +
      idToken +
      "&extension=" +
      this.props.agentInfo.extension +
      "&agent=" +
      this.isWebAgentActive +
      "&exp=" +
      expire +
      "&env=" +
      env +
      "&debug=" +
      getIsDebug();

    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };

    return (
      <div>
        <Tooltip title="Webphone">
          <a
            className="trigger_popup_fricc"
            onClick={() => this.togglePhonePopup()}
            style={{ color: "white" }}
          >
            <span className="icon icon-phone" style={{ fontSize: 22 }}></span>
          </a>
        </Tooltip>
        {/* </li> */}
        <div
          className="hover_bkgr_fricc"
          style={{
            display: this.state.showPhone ? "block" : "none",
            marginLeft: -141,
          }}
        >
          <span className="helper"></span>
          {/* <Draggable {...dragHandlers}> */}
          <div className="box" style={{ position: "absolute" }}>
            <div onClick={() => this.togglePhonePopup()}>
              <iframe id="phone-iframe"></iframe>
            </div>
          </div>
          {/* </Draggable> */}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    agentInfo: state.agentInfo,
    openPhone: state.callEvents.openPhone,
    showInvalidAudioSettingsMessage: state.common.showInvalidAudioSettingsMessage
  };
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		showWebphone,
		set_showInvalidAudioSettingsMessage
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PhoneFooter);



// WEBPACK FOOTER //
// ./src/agent/PhoneFooter.js